import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { SessionService } from '../session/session.service';
import { BalanceService } from '../../balance/balance.service';
import { SystemConfig } from '../../config/system-config';
import { TranslationService } from '../translation/translation.service';

@Injectable()
export class PayoutService {

  constructor(private http: Http,
              public sessionService: SessionService,
              public balanceService: BalanceService,
              public translationService: TranslationService) {
  }

  payout(amount: number): void {
    try {
      if (amount > 0 && amount <= this.sessionService.punter.balance) {
        this.http.post(SystemConfig.Endpoint.PAYOUT, {"Amount": amount}, {
          headers: new Headers()
        }).subscribe((response: Response) => this.handlePayoutResponse(response.json()),
            (error: Error) => {
              this.handlePayoutError();
            });
      } else {
        this.sessionService.showInfoBubbleDialog(this.translationService.translate('punterBar.payout.invalidAmount'), true);
      }
    } catch (e) {
      console.log("payout", e);
    }
  }

  handlePayoutResponse(response: any) {
    if (response.Success) {
      this.sessionService.showInfoBubbleDialog(this.translationService.translateArgs('punterBar.payout.success', response.Code), false);
      this.balanceService.updateBalance();
      this.sessionService.hideFundsDialogs();
    } else {
      this.handlePayoutError();
    }
  }

  handlePayoutError(): void {
    this.sessionService.showInfoBubbleDialog(this.translationService.translate('default.error'), true);
  }
}




// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/services/payout/payout.service.ts